var map = {
	"./Base/serverStyle": 129,
	"./Clutch/serverStyle": 1840,
	"./NewUi/serverStyle": 1841,
	"./OldUi/serverStyle": 1842,
	"./SpireonNew/serverStyle": 1843,
	"./SpireonOld/serverStyle": 1844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;